import { ModalConfig } from "../../../contexts/modalContext";

import PendingAppModal from "./PendingAppModal";
import DisenrollConfirmationModal from "./DisenrollConfirmationModal";
import DisenrollOptionsModal from "./DisenrollOptionsModal";
import SubmitDisenrollModal from "./SubmitDisenrollModal";
import DisenrollFailureModal from "./DisenrollFailureModal";
import DisenrollIneligibleGroupModal from "./DisenrollInelilgibleGroupModal";
import OverageMemberChangePlanModal from "./OverageMemberChangePlanModal";
import OverageAndOtherMemberChangePlan from "./OverageAndOtherMemberChangePlanModal";
import EndOfPHEModal from "./EndOfPHEModal";
import HealthBeforeDentalModal from "./HealthBeforeDentalModal";
import ShopForNewPlanModal from "./ShopForNewPlanModal";
import DentalEnrollmentRequirementModal from "./DentalEnrollmentRequirementModal";
import FailToFormMultiCustomGroupModal from "./FailsToFormMultiCustomgroupModal";
import CustomGroupingFailureModal from "./CustomGroupingFailureModal";
import DisenrollmentFlowModal from "./DisenrollmentFlowModal";
import ChangeApplicationNotToConsiderModal from "./ChangeApplicationNotToConsiderModal";
import PayNow from "./PayNowModal";
import ChangeTerminationDate from "./ChangeTerminationDateModal";
import DisEnrollMembers from "./DisEnrollMembers";
import SubmitSuccess from "./SubmitSuccess";
import AreYouSure from './AreYouSureModal'
import DisEnrollHistoryOptionsModal from "./DisEnrollHistoryOptionsModal";

export const modalConfig:ModalConfig = {
    "pendingAppModal": {
        id: 'pendingApp',
        modalComponent: PendingAppModal
    },
    "disenrollmentConfirmation": {
        id: 'disenrollConfirmation',
        modalComponent: DisenrollConfirmationModal
    },
    "disenrollOptions": {
        id: "disenrollOptions",
        modalComponent: DisenrollOptionsModal
    },
    "submitDisenrollModal": {
        id: 'submitDisenroll',
        modalComponent: SubmitDisenrollModal
    },
    "disenrollFailureModal": {
        id: 'disenrollFailure',
        modalComponent: DisenrollFailureModal   
    },
    "disenrollIneligibleGroupModal": {
        id: 'disenrollIneligibleGroup',
        modalComponent: DisenrollIneligibleGroupModal
    },
    "overageMemberChangePlan": {
        id: 'OverageMemberChangePlan',
        modalComponent: OverageMemberChangePlanModal
    },
    "overageAndOtherMemberChangePlan": {
        id: 'OverageAndOtherMemberChangePlan',
        modalComponent: OverageAndOtherMemberChangePlan
    },
    "healthBeforeDentalModal": {
        id: 'healthBeforeDental',
        modalComponent: HealthBeforeDentalModal
    },
    "shopForNewPlan": {
        id: 'shopForNewPlan',
        modalComponent: ShopForNewPlanModal
    },
    "dentalEnrollmentRequirement": {
        id: 'dentalEnrollmentRequirement',
        modalComponent: DentalEnrollmentRequirementModal
    },
    "endOfPHE": {
        id: 'endOfPHE',
        modalComponent: EndOfPHEModal
    },
    "customGroupingFailure": {
        id: 'failToFormCustomGroup',
        modalComponent: CustomGroupingFailureModal
    },
    "failToFormMultiCustomGroup": {
        id: 'failToFormMultiCustomGroup',
        modalComponent: FailToFormMultiCustomGroupModal
    },
    "disenrollmentFlow": {
        id: 'disenrollmentFlow',
        modalComponent: DisenrollmentFlowModal
    },
    "changeApplicationNotToConsider": {
        id: 'changeApplicationNotToConsider',
        modalComponent: ChangeApplicationNotToConsiderModal
    },
    "payForEnrollment": {
        id: 'payForEnrollment',
        modalComponent: PayNow
    },
    "changeTerminationDate": {
        id: 'changeTerminationDate',
        modalComponent: ChangeTerminationDate
    },
    "disenrollMembers":{
        id: "disenrollMembersModal",
        modalComponent: DisEnrollMembers
    },
    "submitSuccess":{
        id: 'submitSuccessModal',
        modalComponent: SubmitSuccess
    },
    "areYouSure":{
        id: 'areYouSureModal',
        modalComponent: AreYouSure
    },
    "disEnrollHistoryOptions":{
        id: "disEnrollOptions",
        modalComponent: DisEnrollHistoryOptionsModal
    }
}
